export const fileType = [0, 1] // 0: folder, 1: file

export const findFileById = (folders, fileId) => {
    for (const folder of folders) {
        // Check if the current folder or file matches the fileId
        if (folder.id === fileId) {
            return folder;
        }
        // If the folder has children, search recursively within them
        if (folder.children && folder.children.length > 0) {
            const result = findFileById(folder.children, fileId);
            if (result) return result; // Return if file is found in children
        }
    }
    return null; // Return null if file is not found
}

export const isMacOS = () => {
  // Get the user agent string
  const userAgent = window.navigator.userAgent.toLowerCase();
  
  // Get the platform information
  const platform = window.navigator.platform.toLowerCase();
  
  // Check if it's a Mac
  const isMac = /macintosh|macintel|macppc|mac68k|darwin/.test(userAgent) || 
                /mac/.test(platform);
  
  // Return 'mac' for MacBook or 'windows' for Windows
  return isMac ? true : false;
};



export const DEFAULT_SHORTCUTS = {
    Sidebar: [
      {
        id: "sidebar-add-todo",
        key: "Cmd+L",
        action: "Add a new todo file",
      },
      {
        id: "sidebar-add-folder",
        key: "Cmd+F",
        action: "Add a new folder",
      },
      {
        id: "sidebar-nav-left",
        key: "ArrowLeft",
        action: "Navigate to the folder section",
      },
      {
        id: "sidebar-nav-right",
        key: "ArrowRight",
        action: "Navigate to the file section",
      },
      {
        id: "sidebar-nav-up",
        key: "ArrowUp",
        action: "Navigate to the upper folder",
      },
      {
        id: "sidebar-nav-down",
        key: "ArrowDown",
        action: "Navigate to the down folder",
      },
      {
        id: "sidebar-input-close",
        key: "Escape",
        action: "Close the new todo list or new folder",
      },
     
      {
        id: "sidebar-sync",
        key: "Cmd+R",
        action: "Sync with the server",
      },
      {
        id: "sidebar-open-file",
        key: "Ctrl + Alphabets",
        action: "Open a specific file",
      },
    ],
    Tab: [
      {
        id: "tab-prev",
        key: "Option+Z",
        action: "Navigate to the previous todo list",
      },
      {
        id: "tab-next",
        key: "Option+X",
        action: "Navigate to the next todo list",
      },
      {
        id: "tab-specific",
        key: "Cmd+1-9",
        action: "Open a specific todo",
      },
      {
        id: "tab-close",
        key: "Cmd+Y",
        action: "Close a specific todo",
      },

    ],
    Todo: [
      {
        id: "todo-focus",
        key: "Cmd+N",
        action: "Focus on the todo form",
      },
      {
        id: "todo-copy",
        key: "Option+C",
        action: "Copy todo/todos (to paste into another list)",
      },
      {
        id: "todo-paste",
        key: "Option+V",
        action: "Paste a todo into the same or another list",
      },
      {
        id: "todo-delete",
        key: "Delete",
        action: "Delete a specific todo",
      },
      {
        id: "todo-undo",
        key: "Cmd+Z",
        action: "Undo the deletion of items",
      },
    ],
  };
export const WINDOWS_DEFAULT_SHORTCUTS = {
    Sidebar: [
      {
        id: "sidebar-add-todo",
        key: "Ctrl+L",
        action: "Add a new todo file",
      },
      {
        id: "sidebar-add-folder",
        key: "Ctrl+F",
        action: "Add a new folder",
      },
      {
        id: "sidebar-nav-left",
        key: "ArrowLeft",
        action: "Navigate to the folder section",
      },
      {
        id: "sidebar-nav-right",
        key: "ArrowRight",
        action: "Navigate to the file section",
      },
      {
        id: "sidebar-nav-up",
        key: "ArrowUp",
        action: "Navigate to the upper folder",
      },
      {
        id: "sidebar-nav-down",
        key: "ArrowDown",
        action: "Navigate to the down folder",
      },
      {
        id: "sidebar-input-close",
        key: "Escape",
        action: "Close the new todo list or new folder",
      },
     
      {
        id: "sidebar-sync",
        key: "Ctrl+R",
        action: "Sync with the server",
      },
      {
        id: "sidebar-open-file",
        key: "Ctrl + Alphabets",
        action: "Open a specific file",
      },
    ],
    Tab: [
      {
        id: "tab-prev",
        key: "Alt+Z",
        action: "Navigate to the previous todo list",
      },
      {
        id: "tab-next",
        key: "Alt+X",
        action: "Navigate to the next todo list",
      },
      {
        id: "tab-specific",
        key: "Alt+1-9",
        action: "Open a specific todo",
      },
      {
        id: "tab-close",
        key: "Ctrl+Y",
        action: "Close a specific todo",
      },

    ],
    Todo: [
      {
        id: "todo-focus",
        key: "Ctrl+N",
        action: "Focus on the todo form",
      },
      {
        id: "todo-copy",
        key: "Alt+C",
        action: "Copy todo/todos (to paste into another list)",
      },
      {
        id: "todo-paste",
        key: "Alt+V",
        action: "Paste a todo into the same or another list",
      },
      {
        id: "todo-delete",
        key: "Delete",
        action: "Delete a specific todo",
      },
      {
        id: "todo-undo",
        key: "Ctrl+Z",
        action: "Undo the deletion of items",
      },
    ],
  };

